import { DELETE_MAIL, SAVE_MAIL } from "@/apollo/mutations/mail";

import {
  GET_PAGINACION_CORREOS,
  GET_PAGE_CORREOS,
  GET_ESTADOS_MAIL,
  FIND_CORREO_BY_ID_ALL,
} from "@/apollo/queries/mail";

import { exQue, exMut } from "@/utils/gql";
import { renderHtmlFromBuilderJson } from "@/utils/mail";
import { mapCorreoToForm } from "./create";

export const histState = {
  histPagination: {},
  histFilters: {
    fechaInicio: "",
    fechaFin: "",
    idCategoria: { value: 0, text: "Todas" },
    idEstado: { value: 0, text: "Todos" },
    limite: 12,
  },
  histLoading: false,
  histDataTable: [],
  correo: {},
  showCorreoDetalles: false,
  estados: [],
};

export const histMutations = {
  showCorreoDetallesChange(state, show) {
    state.showCorreoDetalles = show;
  },
  setHistPagination(state, pagination) {
    state.histPagination = pagination;
  },
  setPageDataTable(state, dataTable) {
    state.histDataTable = dataTable;
  },
  setHistLoading(state, loading) {
    state.histLoading = loading;
  },

  setEstados(state, estados) {
    state.estados = [
      { value: 0, text: "Todos" },
      ...estados.map((estado) => ({
        ...estado,
        text: estado.nombre_estado,
        value: estado.id_estado,
      })),
    ];
  },

  setCorreo(state, correo) {
    state.correo = correo;
  },
};

export const histActions = {
  async getPagination({ state, commit, dispatch }) {
    try {
      commit("setHistLoading", true);
      commit("setHistPagination", []);
      const pagination = await exQue(
        GET_PAGINACION_CORREOS,
        {
          fechaInicio: state.histFilters.fechaInicio,
          fechaFin: state.histFilters.fechaFin,
          idCategoria: state.histFilters.idCategoria.value,
          idEstado: state.histFilters.idEstado.value,
          limite: state.histFilters.limite,
        },
        true,
      );

      commit("setHistPagination", pagination || []);

      if (pagination && pagination[0]) {
        await dispatch("getPage", pagination[0]);
      } else {
        commit("setPageDataTable", []);
      }
    } catch (error) {
      console.error("Error obteniendo paginación:", error);
      commit("setHistPagination", []);
      commit("setPageDataTable", []);
    } finally {
      commit("setHistLoading", false);
    }
  },

  async getPage({ commit }, pageData) {
    try {
      commit("setHistLoading", true);

      const page = await exQue(
        GET_PAGE_CORREOS,
        { idCorreo: pageData.ids },
        true,
      );
      commit("setPageDataTable", page || []);
    } catch (error) {
      console.error("Error obteniendo página:", error);
      commit("setPageDataTable", []);
    } finally {
      commit("setHistLoading", false);
    }
  },

  async getEstados({ commit }) {
    try {
      const estados = await exQue(GET_ESTADOS_MAIL);
      commit("setEstados", estados || []);
    } catch (error) {
      console.error("Error obteniendo estados:", error);
      commit("setEstados", []);
    }
  },

  async findCorreoById({ commit }, idCorreo) {
    try {
      const correo = await exQue(FIND_CORREO_BY_ID_ALL, { idCorreo });
      commit("setCorreo", correo || {});
    } catch (error) {
      console.error("Error obteniendo correo por ID:", error);
      commit("setCorreo", {});
    }
  },

  async duplicateCorreo({ state, dispatch }, idCorreo) {
    const correo = await exQue(FIND_CORREO_BY_ID_ALL, { idCorreo }).catch(
      () => null,
    );
    if (!correo) return null;

    const mapped = mapCorreoToForm(correo, state.direcciones);

      const hasRows = Array.isArray(mapped?.jsonMail?.rows);
      const fallbackRows = mapped?.htmlMail
        ? [
            {
              id: Date.now() + Math.random(),
              cols: [
                {
                  type: "Html",
                  component: "MailHtmlModule",
                  tag: "div",
                  stylesContainer: {},
                  styles: {},
                  content: mapped.htmlMail,
                  attributes: {},
                },
              ],
            },
          ]
        : null;

      const duplicated = {
        ...mapped,
        id_correo: null,
        programar: false,
        fecha: "",
        hora: "",
        jsonMail: hasRows
          ? mapped.jsonMail
          : {
              rows: fallbackRows || [],
            },
        asunto: mapped?.asunto ? `Copia - ${mapped.asunto}` : mapped?.asunto,
      };

      const usuarios = Array.isArray(duplicated.destinatarios)? duplicated.destinatarios    .map((u) => u?.id || u?.value || u?.correo)    .filter(Boolean)    .map((id) => Number(id))    .filter((id) => !Number.isNaN(id)): [];

      const listas = Array.isArray(duplicated.destinatariosListasSeleccionadas)? duplicated.destinatariosListasSeleccionadas    .map((l) => {      const id = l?.id || l?.id_lista || l?.value;      if (!id) return null;      const correosExcluidos = Array.isArray(l?.correos_excluidos)        ? l.correos_excluidos.filter(Boolean)        : [];      return {        id_lista: Number(id),        correos_excluidos: correosExcluidos,      };    })    .filter(Boolean): [];

      const destinatarios = {
        destinatarios_usuarios: [...new Set(usuarios)],
        destinatarios_listas: listas,
      };

      const archivosAdjuntos = (duplicated.archivosAdjuntos || [])
        .filter((att) => att?.id_archivo || att?.id_adjunto)
        .map((att) => ({
          id_adjunto: Number(att.id_archivo || att.id_adjunto) || null,
          url_adjunto: att.url || "",
          nombre_adjunto: att.nombre || "",
          size: att.size || 0,
          formato: att.type || "",
        }));

      const payload = {
        idCorreo: 0,
        idRemitente: duplicated.direccion?.id || duplicated.direccion?.value || null,
        nombreRemitente:
          duplicated.remitente || duplicated.direccion?.text || "",
        asunto: duplicated.asunto || "(Sin asunto)",
        introduccion: duplicated.introduccion || duplicated.itroduccion || "",
        archivosAdjuntos,
        destinatarios,
        contenidoHtml:
          renderHtmlFromBuilderJson(duplicated) || duplicated.htmlMail || "",
        contenidoJson: JSON.stringify(duplicated.jsonMail || {}),
        isTemplate: false,
        isEraser: true,
        isProgrammed: false,
        fechaProgramada: null,
        horaProgramada: null,
        urlImagenTemplate:
          "https://storage.googleapis.com/bucket-mailing-c3/8375bm_cpts/templates_thumbnails/template_1759940117685.png",
        formatoImagenTemplate: duplicated.formato_imagen_template || null,
        idCategoriaFk: duplicated.id_categoria_fk || null,
      };

      if (!payload.idRemitente) {
        throw new Error("Debe seleccionar una direccion de remitente");
      }
      if (!payload.nombreRemitente) {
        throw new Error("Debe ingresar un nombre de remitente");
      }
      
      const response = await exMut(SAVE_MAIL, payload);

      dispatch("getPagination");

      return response
        ? { ...duplicated, id_correo: response.id_correo || null }
        : duplicated;
  },

  async deleteCorreoById({ dispatch }, idCorreo) {
    try {
      const deleted = await exMut(DELETE_MAIL, { idCorreo });
      if (deleted) {
        dispatch("getPagination");
      }
      return deleted;
    } catch (error) {
      console.error("Error eliminando correo:", error);
      return null;
    }
  },
};
